import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DropdownCommon from "../Common/DropdownCommon";
import AlignTopDemo from "./AlignTopDemo";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { AlignmentsTitle } from "../../../../Constants/Constants";
import { AlignmentData, AlignmentsSubTitle } from "../../../../Data/UiKits/Dropdown";

const Alignments = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={AlignmentsTitle} span={AlignmentsSubTitle} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <AlignTopDemo />
            {AlignmentData &&
              AlignmentData.map((item, index) => (
                <Fragment key={index}>
                  <DropdownCommon item={item} />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Alignments;
